export enum PassportKnmActionsEnum {
  PASSPORT_KNM_GET_DATA = 'PASSPORT_KNM_GET_DATA',
  PASSPORT_KNM_GET_DATA_BY_QR = 'PASSPORT_KNM_GET_DATA_BY_QR',
  PASSPORT_KNM_SET_DATA = 'PASSPORT_KNM_SET_DATA',
  PASSPORT_KNM_SET_ERROR_STATUS = 'PASSPORT_KNM_SET_ERROR_STATUS',
  PASSPORT_KNM_EXPORT_PDF = 'PASSPORT_KNM_EXPORT_PDF',

  PASSPORT_DECISION_GET_DATA = 'PASSPORT_DECISION_GET_DATA',
  PASSPORT_DECISION_GET_DATA_BY_QR = 'PASSPORT_DECISION_GET_DATA_BY_QR',
  PASSPORT_DECISION_SET_DATA = 'PASSPORT_DECISION_SET_DATA',
  PASSPORT_DECISION_EXPORT_PDF = 'PASSPORT_DECISION_EXPORT_PDF',
}
